import { Component } from '@theme/component';

/**
 * Wraps the add-to-cart submit button. The click is allowed to bubble
 * into the form's native submit event, which product-form-component
 * intercepts via on:submit.
 *
 * @extends {Component}
 */
class AddToCartComponent extends Component {
  handleClick() {}

  /**
   * Plays the "added to cart" checkmark animation (driven by the
   * [data-added='true'] CSS rules in base.css).
   */
  playAddedAnimation() {
    if (this.dataset.addToCartAnimation !== 'true') return;

    const button = this.querySelector('[ref="addToCartButton"]');
    if (!(button instanceof HTMLElement)) return;

    button.setAttribute('data-added', 'true');
    window.setTimeout(() => button.removeAttribute('data-added'), 1500);
  }
}

if (!customElements.get('add-to-cart-component')) {
  customElements.define('add-to-cart-component', AddToCartComponent);
}
